import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { IgloohomeLock } from '../../../../../api/PropertyIntegration';
import Button from '../../../../common/form/Button';

interface Props {
    lock: IgloohomeLock;
    deleteLock: (lockToDelete: IgloohomeLock) => Promise<void>;
}

const IgloohomeLockRow = (props: Props) => (
    <Row className="code-row">
        <Col md={3}>
            <span className="code-display">{props.lock.lockName}</span>
        </Col>
        <Col md={3}>
            <span className="code-display">{props.lock.displayName}</span>
        </Col>
        <Col md={3}>
            <span className="code-display">{props.lock.lockUniqueId}</span>
        </Col>
        <Col md={2}>
            <Button
                text="Delete"
                addlClassName="btn-danger"
                onClick={async () => {
                    await props.deleteLock(props.lock);
                }}
            />
        </Col>
    </Row>
);

export default IgloohomeLockRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/IgloohomeLockRow.tsx